module.exports = __webpack_public_path__ + "img/tips.60abb5a0.png";